import { motion } from "framer-motion";
import { WHATSAPP } from "@/constants/testIds";
import { SITE } from "@/data/siteData";

const WhatsAppFloat = () => {
    return (
        <motion.a
            data-testid={WHATSAPP.float}
            href={`https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent(
                "Ciao Senso Unico! Vorrei ordinare una pizza.",
            )}`}
            target="_blank"
            rel="noreferrer"
            initial={{ scale: 0, rotate: -30 }}
            animate={{ scale: 1, rotate: 0 }}
            transition={{ delay: 2.3, type: "spring", stiffness: 220, damping: 15 }}
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.94 }}
            className="wa-pulse fixed z-40 bottom-5 right-5 md:bottom-8 md:right-8 inline-flex items-center gap-2 pl-3 pr-5 py-3 rounded-full bg-[#25D366] text-white font-bold uppercase tracking-wider text-sm border-2 border-[#0a0a0a] shadow-[6px_6px_0_0_#0a0a0a]"
            aria-label="Contattaci su WhatsApp"
        >
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-white text-[#25D366]">
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden>
                    <path d="M20.52 3.48A11.9 11.9 0 0 0 12 0C5.37 0 0 5.37 0 12a11.9 11.9 0 0 0 1.6 6L0 24l6.2-1.63A12 12 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.19-3.48-8.52ZM12 21.8a9.8 9.8 0 0 1-5-1.37l-.36-.22-3.68.97.98-3.58-.24-.37A9.8 9.8 0 1 1 21.8 12 9.82 9.82 0 0 1 12 21.8Zm5.35-7.34c-.29-.15-1.73-.86-2-.96s-.46-.14-.66.15-.76.96-.94 1.16-.35.22-.65.07a8 8 0 0 1-2.35-1.45 8.85 8.85 0 0 1-1.63-2.03c-.17-.29 0-.44.13-.6s.29-.34.44-.51a2 2 0 0 0 .29-.5.55.55 0 0 0 0-.51c-.07-.15-.66-1.6-.9-2.19s-.48-.5-.66-.51h-.56a1.08 1.08 0 0 0-.78.36 3.28 3.28 0 0 0-1 2.45c0 1.44 1.05 2.83 1.19 3s2.07 3.16 5 4.44a17.16 17.16 0 0 0 1.67.61 4 4 0 0 0 1.85.12 3 3 0 0 0 2-1.4 2.44 2.44 0 0 0 .17-1.4c-.07-.13-.26-.2-.55-.35Z" />
                </svg>
            </span>
            WhatsApp
        </motion.a>
    );
};

export default WhatsAppFloat;
